import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Signal.module.css';
import signalVehicleRed from '../../assets/signal_veh_red.svg';
import signalVehicleAmber from '../../assets/signal_veh_yellow.svg';
import signalVehicleGreen from '../../assets/signal_veh_green.svg';
import signalVehicleUndef from '../../assets/signal_veh_undef.svg';
import signalVehicleAmberRed from '../../assets/signal_veh_yellow_red.svg';
import signalTrolleyRed from '../../assets/signal_tro_red.svg';
import signalTrolleyAmber from '../../assets/signal_tro_yellow.svg';
import signalTrolleyGreen from '../../assets/signal_tro_green.svg';
import signalTrolleyUndef from '../../assets/signal_tro_undef.svg';
import signalTrolleyPedestrianOff from '../../assets/signal_ped_tro_green.svg';
import signalTrolleyPedestrianOn from '../../assets/signal_ped_tro_red.svg';
import signalTrolleyPedestrianUndef from '../../assets/signal_ped_tro_undef.svg';
import signalTrolleyAmberRed from '../../assets/signal_tro_yellow_red.svg';
import signalPedestrianRed from '../../assets/signal_ped_red.svg';
import signalPedestrianAmber from '../../assets/signal_ped_amber.svg';
import signalPedestrianGreen from '../../assets/signal_ped_green.svg';
import signalPedestrianUndef from '../../assets/signal_ped_undef.svg';
import signalPrioOn from '../../assets/signal_prio_on.svg';
import signalPrioOff from '../../assets/signal_prio_off.svg';
import signalPrioUndef from '../../assets/signal_prio_undef.svg';
import { FaRegCompass } from 'react-icons/fa';
import { isPedestrianSignal, isPrioritySignal, isTrolleyPedestrianSignal, isTrolleySignal } from "./SignalGroup";
import { greens, ambers, amberReds, reds, undefineds, GREEN, AMBER, AMBER_REDS, RED, UNDEF, stateDescriptions } from './signalStates';

const Signal = (props) => {
    const signal = props.signal;


    const statusCodes = new Map([
        ...greens.map((i) => [i, GREEN]),
        ...ambers.map((i) => [i, AMBER]),
        ...amberReds.map((i) => [i, AMBER_REDS]),
        ...reds.map((i) => [i, RED]),
        ...undefineds.map((i) => [i, UNDEF])]);

    const getSignalIcon = (signal) => {
        const status = statusCodes.get(signal.status);

        if (isPedestrianSignal(signal)) {
            switch (status) {
                case RED: return signalPedestrianRed;
                case AMBER: return signalPedestrianAmber;
                case GREEN: return signalPedestrianGreen;
                default: return signalPedestrianUndef;
            }
        } else if (isTrolleyPedestrianSignal(signal)) {
            switch (status) {
                case RED: return signalTrolleyPedestrianOff;
                case GREEN: return signalTrolleyPedestrianOn;
                default: return signalTrolleyPedestrianUndef;
            }
        } else if (isTrolleySignal(signal)) {
            switch (status) {
                case RED: return signalTrolleyRed;
                case AMBER: return signalTrolleyAmber;
                case GREEN: return signalTrolleyGreen;
                case AMBER_REDS: return signalTrolleyAmberRed;
                default: return signalTrolleyUndef;
            }
        } else if (isPrioritySignal(signal)) {
            switch (status) {
                case RED: return signalPrioOff;
                case GREEN: return signalPrioOn;
                default: return signalPrioUndef;
            }
        } else {
            switch (status) {
                case RED: return signalVehicleRed;
                case AMBER: return signalVehicleAmber;
                case GREEN: return signalVehicleGreen;
                case AMBER_REDS: return signalVehicleAmberRed;
                default: return signalVehicleUndef;
            }
        }
    };

    const signalIcon = getSignalIcon(signal);
    const { t } = useTranslation();

    return (
        <div className={classes.Signal}>
            <FaRegCompass title={t('signal.direction')} /> {signal.name}<br />

            <div className={classes.SignalContainer}>
                <img
                    className={isTrolleyPedestrianSignal(signal) ? classes.SignalHorizontal : classes.Signal}
                    src={signalIcon}
                    alt={statusCodes.get(signal.status)}
                    title={`${signal.status}: ${stateDescriptions[signal.status]?.short}`}
                />
            </div>

        </div>
    );
};

export default Signal;
